export default __webpack_public_path__ + "static/media/sc191.c59335f1.mp4";